import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { StateChange } from 'ng-lazyload-image';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { Category } from 'src/@omnial/_models/catalog/category.model';
import { Product, ProductDetail } from 'src/@omnial/_models/catalog/product.model';
import { CatalogService } from 'src/@omnial/_services/catalog/catalog.service';
import { TrackingService } from 'src/@omnial/_services/external/tracking.service';
import { CanonicalService } from 'src/@omnial/_services/navigation/canonical.service';
import { ProductDialogComponent } from 'src/@omnial/shared/product-dialog/product-dialog.component';
import { AppSettings } from 'src/app/app.settings';

@Component({
    selector: 'app-product-content',
    templateUrl: './../../../app/shared/product-content/product-content.component.html',
    styleUrls: ['./../../../app/shared/product-content/product-content.component.scss'],
    standalone: false
})
export class ProductContentComponent implements OnInit, OnDestroy {
  @Input() productId: number;
  public product: Product = null;
  public category: Category = null;
  public subscriptions: Subscription[] = [];

  constructor(
    public dialog: MatDialog,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public catalogService: CatalogService,
    public canonicalService: CanonicalService,
    public trackingService: TrackingService,
    public settings: AppSettings,
    public spinner: NgxSpinnerService) { }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => { sub.unsubscribe(); });
    }
  }

  ngOnInit(): void {
    this.subscriptions.push(this.catalogService.getProduct(this.productId).subscribe({
      next: (res) => {
        this.product = res;
      },
      error: (err) => {
        console.log(err);
      },
    }));
  }

  public productClick(product: Product): void {
    this.trackingService.pushProductClick(product, 'content', 'content', 1);
    this.subscriptions.push(this.canonicalService.productCanonical(product).subscribe(
      res => {
        if (res) {
          this.router.navigate([`${res}/${product.seName}`]);
        } else {
          this.router.navigate([`/products/${product.id}`]);
        }
      }
    ))
  }

  public openProductDialog(productSimple: Product): void {
    this.spinner.show();
    this.trackingService.pushProductClick(productSimple, 'content', 'content', 1);
    this.subscriptions.push(this.catalogService.getProductDetail(productSimple.id).subscribe(
      res => {
        this.spinner.hide();
        const product = res as ProductDetail;
        const dialogRef = this.dialog.open(ProductDialogComponent, {
          data: { product, category: null, listId: 'content' },
          panelClass: 'product-dialog',
          direction: (this.settings.rtl) ? 'rtl' : 'ltr'
        });
        dialogRef.afterClosed().subscribe(productDialog => {
          if (productDialog) {
            this.router.navigate([product.seName], { relativeTo: this.activatedRoute });
          }
        });
      }));
  }

  public imageStateChange(event: StateChange, product: Product): void {
    if (event?.reason === 'loading-succeeded') {
      this.trackingService.pushImpression(product, 'content', 'content', 1);
    }
  }

  public productSpecificationAttribute(product: Product, specificationAttributeName: string): string {
    return product?.specifications?.find(s => s.specificationAttributeName === specificationAttributeName)?.valueRaw;
  }
}
